<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods, erpUserRolesMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { required } from "vuelidate/lib/validators";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Category Promo component
   */
  export default {
    page: {
      title: "Category Promo Form",
    },
    data() {
      return {
        title: "Category Promo form",
        category_name: "",
        categoryId: 0,
        submitted: false,
        formExitChecker: "",
        eloadCategoryModule: {
          access: {
            create: true,
            update: true
          }
        }
      };
    },
    validations:{
      category_name:{required}
    },
    computed: {
      ...digitalLoadComputed,
      rows() {
        return this.itemsCategory.length
      }
    },
    mounted: async function() {
      this.categoryId = this.$route.params.id;
      this.changeTitle({title: (this.categoryId > 0 ? "Edit" : "Add") + ' Category Promo'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'Category Promo', to: { name: 'Category Promo'} },
          { text: 'Category Promo Form', to: { name: 'Category Promo'} }
        ]
      });
      if (this.categoryId > 0) {
        // alert("Edit");
        this.editCategory();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Category')
      .then((access) => this.eloadCategoryModule.access = access);
      
    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...erpUserRolesMethods,
      createEloadCategory() {
        this.submitted = true
        this.$v.$touch();

        if (!this.$v.category_name.$invalid){
          this.actionCategory({
            action: "create",
            body:{categoryName: this.category_name}
          })
          .then(() => {
            // this.$alertify.success("Added Successfully");
            Swal.fire(
              "Create Successful!",
              `${this.category_name} has been created.`,
              "success"
            );
            this.category_name = ""
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "Category Promo"
              }
            );
          })
          .catch(function(error) {
            // this.$alertify.error(error);
            Swal.fire(
              "Create Failed! ",
              error,
              "warning"
            );
            console.log(error);
            this.category_name = ""
          });
        }
      },
      updateEloadCategory() {
        this.submitted = true
        this.$v.$touch();

        if (!this.$v.category_name.$invalid){
          this.actionCategory({
            action: "update",
            body:{
              categoryName: this.category_name,
              id: this.categoryId.toString()
            }
          })
          .then(() => {
            // this.$alertify.success("Updated Successfully");
            Swal.fire(
              "Updated Successful!",
              `${this.category_name} has been updated.`,
              "success"
            );
            this.category_name = ""
            this.categoryId = 0
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "Category Promo"
              }
            );
            return;
          })
          .catch(function(error) {
            console.log(error);
            // this.$alertify.error(error);
            Swal.fire(
              "Update Failed!",
              error,
              "warning"
            );
            this.category_name = ""
            this.categoryId = 0
            return;
          });
        }
      },
      formHandler(){
        if(this.categoryId > 0){
          console.log("hey edit");
          this.updateEloadCategory();
        }else{
          console.log("hey create");
          this.createEloadCategory();
        }
      },
      editCategory() {
        this.getEloadCategoryDetails({"categoryId" : this.categoryId}).then((data) => {
          this.categoryId = data.categoryId;
          this.category_name = data.categoryName;
          this.formExitChecker = data.categoryName;
          console.log(">> DATA:",data);
          console.log(">> formExitChecker:",this.formExitChecker);
        });
      },
    }
  }
    
</script>

<template>
  <div class="row">
    <div class="col-md-3">&nbsp;</div>
    <div class="card col-md-6">
      <div class="card-body">
        <form class="px-4 py-3" @submit.prevent="formHandler()">
          <label v-if="(categoryId <= 0 || isNaN(categoryId)) && !eloadCategoryModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a promo.</label>
          <label v-else-if="categoryId > 0 && !eloadCategoryModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a promo.</label>
          <div class="mb-3">
            <label class="form-label"
              >Category Name<span style="color: red">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="addcontact-name-input"
              v-model="category_name"
              placeholder="Enter Category Name"
              :class="{
                'is-invalid':
                  submitted && $v.category_name.$error,
              }"
          
            />
          </div>
            
          <div class="row">
            <div class="col-md-6 mt-3">
              <b-button :disabled="categoryId > 0 ? !eloadCategoryModule.access.update : !eloadCategoryModule.access.create" variant="primary" class="w-sm w-100p" type="submit">{{categoryId > 0 ? 'Update':'Save'}}</b-button>
            </div>
            <div class="col-md-6 mt-3">
              <router-link :to="{ name: 'Category Promo', params: {} }" class="tc-white">
                <b-button variant="light" class="w-sm w-100p" type="button" >Cancel</b-button>
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>